import { Target, Zap, Square } from "lucide-react";

export default function PlayerPredictions({ players = [], homeName, awayName, stats }) {
  if (!players.length) return null;
  const byName = {};
  ["home", "away"].forEach((s) => (stats?.[s]?.players || []).forEach((p) => (byName[p.name] = p)));

  return (
    <div className="surface-raised p-6" data-testid="player-predictions">
      <div className="flex items-center justify-between mb-5">
        <div className="label">Giocatori Chiave</div>
        <div className="label text-[10px] text-[#71717A]">{players.length} analizzati</div>
      </div>

      <div className="space-y-2">
        {players.map((p) => (
          <PlayerRow key={`${p.team}-${p.name}`} p={p} homeName={homeName} awayName={awayName} season={byName[p.name]} />
        ))}
      </div>

      <div className="mt-5 pt-4 border-t border-[#27272A] flex items-center gap-6 text-[10px] text-[#71717A]">
        <Legend icon={Target} label="GOL" color="#39FF14" />
        <Legend icon={Zap} label="ASSIST" color="#007AFF" />
        <Legend icon={Square} label="GIALLO" color="#FFCC00" />
      </div>
    </div>
  );
}

function Legend({ icon: Icon, label, color }) {
  return (
    <div className="flex items-center gap-1.5">
      <Icon size={10} strokeWidth={2} color={color} />
      <span className="label text-[9px]">{label}</span>
    </div>
  );
}

function PlayerRow({ p, homeName, awayName, season }) {
  const teamLabel = p.team === "home" ? homeName : awayName;
  const max = Math.max(p.goal_probability || 0, p.assist_probability || 0, p.card_probability || 0);
  const highlight = max >= 50;

  return (
    <div
      className={`grid grid-cols-[1fr_auto] gap-3 p-3 border transition-colors ${
        highlight ? "border-[#39FF14]/40 bg-[#39FF14]/5" : "border-[#27272A] hover:border-[#3f3f46]"
      }`}
      data-testid={`player-row-${p.name}`}
    >
      <div className="min-w-0">
        <div className="flex flex-wrap items-baseline gap-x-2">
          <div className="font-bold leading-tight break-words">{p.name}</div>
          <span className="label text-[9px] text-[#71717A]">{teamLabel}</span>
        </div>
        {season && (
          <div className="mono text-[10px] text-[#71717A] mt-0.5">
            {season.goals} gol · {season.assists} ass · {season.shots} tiri · {season.yellow_cards} gialli · {season.fouls_committed} falli
          </div>
        )}
        {p.note && <div className="text-xs text-[#A1A1AA] mt-0.5 line-clamp-2">{p.note}</div>}
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <StatPill icon={Target} value={p.goal_probability} color="#39FF14" />
        <StatPill icon={Zap} value={p.assist_probability} color="#007AFF" />
        <StatPill icon={Square} value={p.card_probability} color="#FFCC00" />
      </div>
    </div>
  );
}

function StatPill({ icon: Icon, value, color }) {
  return (
    <div className="flex items-center gap-1.5 min-w-[46px]">
      <Icon size={12} strokeWidth={2} color={color} />
      <span className="mono font-black text-sm" style={{ color }}>{value ?? 0}%</span>
    </div>
  );
}
